var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPasssword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.45015C2.37362 -0.91644 14.385 -0.873219 16 7.45015M12.25 8.0751C12.25 10.1462 10.5711 11.8251 8.5 11.8251C6.42893 11.8251 4.75 10.1462 4.75 8.0751C4.75 6.00404 6.42893 4.3251 8.5 4.3251C10.5711 4.3251 12.25 6.00404 12.25 8.0751Z",
    stroke: "#626262",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasssword);
export default __webpack_public_path__ + "static/media/show-passsword.51fab1014fc10821ba5aed7a190dc5d2.svg";
export { ForwardRef as ReactComponent };